module.exports = __webpack_public_path__ + "static/media/lashpic4.24c74a93.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Pretty_Lashed/gp/lashpic4.PNG
// module id = 452
// module chunks = 0